import styled, { css } from "styled-components";

export const FilesContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;

  svg {
    margin-left: 8px;
    cursor: pointer;
  }
`;

export const Dropzone = styled.div`
  width: 100%;
  height: 180px;
  border: 2px dashed #000;
  margin-top: 26px;

  display: flex;
  align-items: center;
  justify-content: center;

  p {
    font-size: 18px;
    color: #465eb6;
    font-weight: bold;
  }
`;
export const Title = styled.span`
  color: #031795;
  font-weight: bold;
  font-size: 18px;
`;

export const SendExtractButton = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
`;

export const SlotCommitteesLinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SlotCommitteeItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const SlotCommitteeName = styled.span`
  font-size: 14px !important;
`;

export const SlotCommitteeLink = styled.a`
  font-size: 14px !important;
  color: #465eb6;
  font-weight: bold;
  cursor: pointer;
`;
